export default __webpack_public_path__ + "static/media/FINANCE-04.b1fb387d.png";